export function formatStayAmount(
  amount: string | number | null | undefined,
  currency = "EUR",
  pricePending = false,
): string {
  if (pricePending) return "Preis folgt";
  return formatCurrency(amount, currency);
}

export function formatCurrency(
  amount: string | number | null | undefined,
  currency = "EUR",
): string {
  if (amount == null || amount === "") return "—";
  const num = typeof amount === "string" ? Number(amount) : amount;
  if (Number.isNaN(num)) return "—";
  return new Intl.NumberFormat("de-DE", { style: "currency", currency }).format(num);
}

export function grossFromNet(net: number, taxRatePercent: number): number {
  return net * (1 + taxRatePercent / 100);
}

export function netFromGross(gross: number, taxRatePercent: number): number {
  if (taxRatePercent === 0) return gross;
  return gross / (1 + taxRatePercent / 100);
}

export function toAmountNumber(amount: string | number | null | undefined): number | null {
  if (amount == null || amount === "") return null;
  const num = typeof amount === "string" ? Number(amount) : amount;
  return Number.isFinite(num) ? num : null;
}

/** Bruttobetrag aus Netto (Rundung auf 2 Nachkommastellen). */
export function grossAmountFromNet(
  net: string | number | null | undefined,
  taxRatePercent: string | number,
): number | null {
  const n = toAmountNumber(net);
  if (n == null) return null;
  const rate = Number(taxRatePercent) || 0;
  return Math.round(grossFromNet(n, rate) * 100) / 100;
}

/** Netto so, dass der Bruttopreis nach Rundung exakt dem Ziel entspricht. */
export function netForTargetGross(
  gross: string | number | null | undefined,
  taxRatePercent: string | number,
): number | null {
  const g = toAmountNumber(gross);
  if (g == null) return null;
  const rate = Number(taxRatePercent) || 0;
  const target = Math.round(g * 100) / 100;
  if (rate === 0) return target;
  const exact = g / (1 + rate / 100);
  const base = Math.round(exact * 10000);
  for (let delta = -200; delta <= 200; delta++) {
    const net = Math.round((base + delta) * 100) / 10000;
    if (net < 0) continue;
    const back = Math.round(net * (1 + rate / 100) * 100) / 100;
    if (back === target) return net;
  }
  return Math.round(exact * 100) / 100;
}

/** Nettobetrag aus Brutto – Ziel-Bruttopreis bleibt nach Umrechnung erhalten. */
export function netAmountFromGross(
  gross: string | number | null | undefined,
  taxRatePercent: string | number,
): number | null {
  return netForTargetGross(gross, taxRatePercent);
}

/** Formatiert einen Nettopreis als Bruttopreis für die Anzeige. */
export function formatGrossFromNet(
  net: string | number | null | undefined,
  taxRatePercent: string | number,
  currency = "EUR",
): string {
  const gross = grossAmountFromNet(net, taxRatePercent);
  if (gross == null) return "—";
  return formatCurrency(gross, currency);
}

export function parseAmount(value: string): number | null {
  const trimmed = value.trim();
  if (!trimmed) return null;
  const num = Number(trimmed);
  return Number.isFinite(num) && num >= 0 ? num : null;
}
